import HekateOptionListElement from './HekateOptionListElement';
export default class HekateMultiSelectOptionElement extends HekateOptionListElement {
    constructor({ value, displayName, isSelected, }) {
        super({ value, displayName });
        this.isSelected = isSelected;
    }
}
